import { TopScorers as CompetitionTopScorers, ITopScorers } from '@sky-it-livedata/livedata-sports-design-system';
import { WidgetContext } from "../../types/WidgetContext";
import { CompetitionScorersRankingQuery } from "./types";
import { log } from "../../utils/log";
import transformer from './transformers/query';
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<CompetitionScorersRankingQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
    props,
  }: WidgetContext<CompetitionScorersRankingQuery>): ITopScorers => {
    return transformer(props);
  }


const competitionTopScorers = ({
  props,
  ...rest
}: WidgetContext<ITopScorers>) => {
    log({ props, ...rest });
    const intCmpEventHandler = useIntcmp();
    const {rows = [], isTopTen = true, pages, ctaLink} = props;

    return (
      <div onClick={intCmpEventHandler}>
        <CompetitionTopScorers 
          rows={rows}
          isTopTen={isTopTen}
          pages={pages}
          ctaLink={ctaLink}
          showTopScorersTitle={isTopTen}
        />
      </div>
    )
}

export default competitionTopScorers;
